var _style, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTreeStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 91.7 81.1",
    style: {
      enableBackground: "new 0 0 91.7 81.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#6C6C99;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3.1,
    y: -9.4,
    className: "st0",
    width: 100,
    height: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.5,34.4h18.8c3.4,0,6.2-2.8,6.2-6.2V9.4c0-3.4-2.8-6.2-6.2-6.2H62.5c-3.4,0-6.2,2.8-6.2,6.2v6.2h-3.1 c-3.3,0-6.5,1.3-8.8,3.7c-2.4,2.4-3.7,5.5-3.7,8.8v9.4h-9.4v-4.7c0-3.4-2.8-6.2-6.2-6.2H9.4c-3.4,0-6.2,2.8-6.2,6.2v15.6 c0,3.4,2.8,6.2,6.2,6.2H25c3.4,0,6.2-2.8,6.2-6.2v-4.7h9.4v9.4c0,3.3,1.3,6.5,3.7,8.8c2.4,2.4,5.5,3.7,8.8,3.7h3.1v6.2 c0,3.4,2.8,6.2,6.2,6.2h18.8c3.4,0,6.2-2.8,6.2-6.2V53.1c0-3.4-2.8-6.2-6.2-6.2H62.5c-3.4,0-6.2,2.8-6.2,6.2v6.2h-3.1 c-1.7,0-3.2-0.7-4.4-1.8c-1.3-1.2-1.9-2.7-1.9-4.4v-25c0-1.7,0.7-3.2,1.8-4.4c1.2-1.2,2.7-1.8,4.4-1.8h3.1v6.2 C56.3,31.5,59.1,34.4,62.5,34.4z M25,48.4H9.4V32.8H25V48.4z M62.5,53.1h18.8v18.8H62.5V53.1z M62.5,9.4h18.8v18.7H62.5V9.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreeStructure);
export default __webpack_public_path__ + "static/media/icon_tree_structure.977f49a6749ef84a4d1336561b4461cb.svg";
export { ForwardRef as ReactComponent };